import { render, staticRenderFns } from "./DocumentNumberInput.vue?vue&type=template&id=59ca523a"
import script from "./DocumentNumberInput.vue?vue&type=script&lang=js"
export * from "./DocumentNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports